import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import API_BASE_URL from "../apiBase";
// import "./CareerApplyModern.css";

export default function CareerApplyModern() {
  const initialForm = {
    fullName: "",
    email: "",
    phone: "",
    profession: "",
    skills: "",
    workExperience: "",
    address: "",
  };

  const [form, setForm] = useState(initialForm);
  const [cv, setCv] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const updateField = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!form.fullName.trim() || !form.email.trim() || !form.phone.trim()) {
      setError("Full name, email, and phone are required.");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("full_name", form.fullName);
      formData.append("email", form.email);
      formData.append("phone", form.phone);
      formData.append("profession", form.profession);
      formData.append("skills", form.skills);
      formData.append("work_experience", form.workExperience);
      formData.append("address", form.address);
      if (cv) {
        formData.append("cv", cv);
      }

      const res = await fetch(`${API_BASE_URL}/submit_career.php`, {
        method: "POST",
        body: formData,
      });

      const rawText = await res.text();
      let data;
      try {
        data = JSON.parse(rawText);
      } catch {
        throw new Error(`Server returned invalid response: ${rawText.slice(0, 200)}`);
      }

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Unable to submit application.");
      }

      setMessage(data.message || "Career application submitted successfully.");
      setForm(initialForm);
      setCv(null);
      e.target.reset();
    } catch (err) {
      setError(err.message || "Unable to connect to server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="career-modern-wrapper">
      <Header />
      {/* Modern Header Banner */}
      <section className="modern-hero d-flex align-items-center">
        <div className="container text-center">
          <h1 className="fw-bold text-white display-5">Career Application</h1>
          <p className="text-white-50 mt-2">
            Submit your details and join our team
          </p>
        </div>
      </section>

      {/* Form Section */}
      <section className="py-5">
        <div className="container">
          <div className="form-card shadow-lg p-4 rounded-4 mx-auto">
            <h3 className="text-center fw-bold mb-4 modern-heading">
              Send Your Details
            </h3>

            <form onSubmit={handleSubmit}>
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}
              {message && (
                <div className="alert alert-success" role="alert">
                  {message}
                </div>
              )}

              <div className="row g-3">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control modern-input"
                    placeholder="Full Name"
                    value={form.fullName}
                    onChange={(e) => updateField("fullName", e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="email"
                    className="form-control modern-input"
                    placeholder="Email Address"
                    value={form.email}
                    onChange={(e) => updateField("email", e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="row g-3 mt-1">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control modern-input"
                    placeholder="Phone"
                    value={form.phone}
                    onChange={(e) => updateField("phone", e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control modern-input"
                    placeholder="Profession"
                    value={form.profession}
                    onChange={(e) => updateField("profession", e.target.value)}
                  />
                </div>
              </div>

              <div className="mt-3">
                <input
                  type="text"
                  className="form-control modern-input"
                  placeholder="Skills (e.g. React, UI/UX, Management)"
                  value={form.skills}
                  onChange={(e) => updateField("skills", e.target.value)}
                />
              </div>

              <div className="mt-3">
                <textarea
                  className="form-control modern-input"
                  rows="4"
                  placeholder="Work Experience"
                  value={form.workExperience}
                  onChange={(e) => updateField("workExperience", e.target.value)}
                ></textarea>
              </div>

              <div className="mt-3">
                <label className="form-label fw-semibold">Upload CV</label>
                <input
                  type="file"
                  className="form-control modern-input"
                  accept=".pdf,.doc,.docx"
                  onChange={(e) => setCv(e.target.files?.[0] || null)}
                />
              </div>

              <div className="mt-3">
                <textarea
                  className="form-control modern-input"
                  rows="3"
                  placeholder="Full Address"
                  value={form.address}
                  onChange={(e) => updateField("address", e.target.value)}
                ></textarea>
              </div>

              <div className="text-center mt-4">
                <button
                  type="submit"
                  className="btn submit-btn px-5 py-2 rounded-3"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit Application"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
